import * as React from 'react'
import { RatingScale } from './types'
import { ScaleBadge } from './scale-badge'

type ListingScaleCardProps = {
  scale: RatingScale
}

export const ListingScaleCard: React.FC<ListingScaleCardProps> = ({
  scale,
}) => {
  return (
    <div className="rounded-[12px] border border-[#D9DDE7] bg-white px-5 py-5">
      <div className="flex items-start justify-between gap-4">
        <h4 className="mb-0 text-[16px] font-medium leading-6 text-[#1D264A]">
          {scale.label}
        </h4>

        <ScaleBadge label={scale.label} color={scale.color} />
      </div>

      <div
        className="mt-2 mb-0 text-[16px] font-normal leading-6 text-[#5E6580] [&_p]:mb-2 [&_p:last-child]:mb-0 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:underline [&_a]:text-[#2E9E5D]"
        dangerouslySetInnerHTML={{ __html: scale.description }}
      />
    </div>
  )
}
